/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React from 'react';
import { NavLink } from 'react-router-dom';
import { shape, string, func } from 'prop-types';

import { createUrl } from 'utils/urlHelper';

import BlackTieIcon from 'components/BlackTieIcon/BlackTieIcon';

import styles from './talent.scss';

/**
 * This is the Talent component.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
export const Talent = ({
  slug,
  talent_id,
  title,
  info,
  picture: { square_url: image },
  onRemove,
}) => (
    <article className={styles.wrapper}>
      <NavLink
        className={styles.image}
        to={createUrl('profile', slug)}
        style={{
          backgroundImage: `url(${image})`,
        }}
      />

      <NavLink className={styles.content} to={createUrl('profile', slug)}>
        <span className={styles.title}>{title}</span>
        <span className={styles.info}>{info}</span>
      </NavLink>

      <div className={styles.buttons}>
        <button
          type="button"
          className={styles.button}
          onClick={() => onRemove(talent_id)}
        >
          <BlackTieIcon icon="times-circle" />
        </button>
      </div>
    </article>
  );

/**
 * Declare expected prop types.
 *
 * @type {Object}
 */
Talent.propTypes = {
  title: string.isRequired,
  info: string.isRequired,
  picture: shape({
    square_url: string.isRequired,
  }).isRequired,
  talent_id: string.isRequired,
  slug: string.isRequired,
  onRemove: func,
};

/**
 * Declare default props.
 *
 * @type {Object}
 */
Talent.defaultProps = {
  onRemove: () => { },
};

export default Talent;
